module.exports = __webpack_public_path__ + "img/cattunnel20.6af4cfdb.jpg";